import React, { useState } from 'react';
import LazyLoadVideo from '../LazyLoadVideo';
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";

const effects = [
  { 
    label: 'Muscular Flex', 
    value: 'muscle', 
    video: 'https://delivery626.nyc3.cdn.digitaloceanspaces.com/video_qm3sdmm9zim5es0rg0.mp4'
  },
  { 
    label: 'Hugging', 
    value: 'hug', 
    video: 'https://delivery626.nyc3.cdn.digitaloceanspaces.com/video_w1dki2hp96rm5hr2i9a.mp4'
  }
];

const EffectsSelector = ({ selectedEffect, setSelectedEffect }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border rounded-lg shadow-sm">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 flex items-center justify-between bg-white rounded-lg hover:bg-gray-50"
      >
        <span className="font-medium text-gray-700">Select Effect</span>
        {isOpen ? (
          <IoIosArrowDown className="w-5 h-5 text-gray-500 transition-transform duration-200" />
        ) : (
          <IoIosArrowForward className="w-5 h-5 text-gray-500 transition-transform duration-200" />
        )}
      </button>
      
      {isOpen && (
        <div className="flex gap-4 overflow-x-auto pb-1 p-4 scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-100">
          <div className="flex gap-6">
            {effects.map((effect) => (
              <div 
                key={effect.value} 
                className={`flex-none w-40 h-48 relative group flex flex-col gap-3 cursor-pointer transition-transform duration-300 ease-in-out transform hover:scale-105 ${
                  selectedEffect === effect.value 
                    ? 'ring-2 ring-purple-500 rounded-xl shadow-lg' 
                    : 'hover:shadow-lg'
                }`}
                onClick={() => setSelectedEffect(effect.value)}
              >
                <div className="absolute inset-0 rounded-xl overflow-hidden">
                  <LazyLoadVideo 
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    dataSrc={effect.video}
                    alt={effect.label}
                    loop 
                    autoPlay 
                    muted
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="text-white font-medium text-sm tracking-wide">
                    {effect.label}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EffectsSelector; 